module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/04-baf7674d0bd71a8653faac9a1b7ce1aa.jpg";